// Profile of Adrian Eisenmeier, German. Source of the profile page and of the PDF in this language.
module.exports = {
  headline: 'Diplom-Physiker • KI-Experte • Softwareentwickler',
  summary: 'Adrian Eisenmeier entwickelt Systeme und berät dort, wo KI, Softwarearchitektur, Datenschutz und Sicherheit praktisch zusammenlaufen: Intent-Driven Development für KI-gestützte Softwareentwicklung, lokale PII-Anonymisierung, Finance-Auswertung und praxisnahe Schulung.',
  imageAlt: 'Porträt von Adrian Eisenmeier',
  personal: {
    position: 'Gründer und Geschäftsführer der pAIoneer Labs GmbH',
    birthdate: '13.06.1985',
    nationality: 'deutsch',
    maritalStatus: 'ledig',
    languages: 'Deutsch (Muttersprache), Englisch (fließend), Niederländisch (Grundkenntnisse)',
    programmingLanguages: 'Python (16 Jahre), R (17 Jahre), C# (9 Jahre), C/C++ (11 Jahre), JavaScript Full Stack (React, TypeScript) (5 Jahre)'
  },
  education: [
    {
      period: '2007 - 2016',
      field: 'Studium: Physik, Meteorologie',
      institution: 'Albert-Ludwigs-Universität Freiburg, Deutschland',
      degree: 'Abschluss: Diplom Physiker'
    }
  ],
  skills: [
    {
      title: 'Agentische KI & LLM Engineering',
      description: 'Agentische KI-Systeme, Intent-Driven Development (IDD), OpenCode- und Claude-Code-Workflows, Agent Instructions und Skills, Model Context Protocol (MCP) mit Python, TypeScript, PHP und C#, lokale LLM-Stacks mit vLLM, Ollama und Hugging Face, RAG/GraphRAG/Agentic-RAG-Architekturen, RAG Evals, Explainable AI, Prompt Engineering, Modell-Quantisierung und Fine-Tuning mit PEFT/LoRA'
    },
    {
      title: 'Data Science, Machine Learning & Signal Analytics',
      description: 'Scikit-Learn, H2O, TensorFlow-Keras, PyTorch, SciPy, ML.NET, Random Forest, LSTM, neuronale Netze, Boltzmann-, Hopfield- und Jordan-Netze, Computer Vision und Bildverarbeitung mit OpenCV, SkiaSharp und Pillow, SIFT, SURF, ORB, Laplace- und Fourier-Transformationen, Signal-Rausch-Analyse, Zeitreihenanalyse, Forecasting, ARIMA und pyramid Auto-ARIMA, NLP, Service-Call-Analyse, KPI-Aggregation, Predictive Models, FAME-Migration, Chou Combination Index und Machine Learning für Medizintechnik und Pharma'
    },
    {
      title: 'Software Engineering, Frameworks & UI',
      description: 'Python, R, C#, C++, C, JavaScript, TypeScript, React, Java, Android, Lua, Bash, PHP, MATLAB, Mathematica, .NET 6/8, C++20, C++/CLI, BeeWare, Toga UI, Xamarin Forms, MAUI, HTML5, CSS, Desktop-, Mobile- und Web-UIs, Softwarearchitektur, Backend- und Full-Stack-Architektur, Event-Driven Architecture und Digital Twins'
    },
    {
      title: 'API-Design, Services & Integration',
      description: 'ASP.NET/ASP, FastAPI, Flask API, Plumber, REST APIs, gRPC, Swagger/OpenAPI, API Design, Service Contracts, Microservices-nahe REST-Architekturen, C# gRPC-Services mit Reflection, Python-FastAPI-Backends, Taiga-, Jira- und Azure-DevOps-API-Integrationen, Robotik- und IoT-Service-Anbindungen sowie Authentifizierungs- und Backend-Integrationen'
    },
    {
      title: 'Datenbanken, ORM & Persistenz',
      description: 'SQL, SQL Server, SQLite, MySQL, Azure SQL, Azure Cosmos DB, Entity Framework und Entity Framework Core als ORM-Schicht, SQL-Datenbanken für Anonymisierung, Zeitreihen-, Tick-, Markt-, Wetter- und Energiedaten, Vektordatenbanken mit ChromaDB und Qdrant, RAG-Dokumentenindizes, Datenqualitätsprüfung und Reporting-Validierung'
    },
    {
      title: 'Cloud, DevOps & Infrastruktur',
      description: 'Linux- und Windows-Serveradministration, GPU- und Edge-KI-Infrastruktur, Docker, Docker Compose, Podman, Kubernetes, Container Services, lokale On-Premise-LLM-Stacks, Azure Functions, IoT Hub, Event Hub, Digital Twins, Key Vault und Time Series Insights, AWS EC2, ECS, S3 und Lambda, Azure DevOps, GitLab Pipelines, GitLab Runners und Executors, Caddy, Nginx, Let\'s Encrypt, lokale Testumgebungen und Container-Orchestrierung auf Sensorhardware'
    },
    {
      title: 'Dashboards, Reporting & Monitoring',
      description: 'R Shiny, Python Shiny, ShinyProxy, Grafana, Kibana, CheckMK Dashboards, Zabbix, RMarkdown, Shiny-Log-Analyse-Dashboards, Kibana Monitoring, KPI- und Prozessvisualisierung, Controlling-Systeme, statistische Reports, tägliche Reporting-Validierung und operative Monitoring-Ansichten'
    },
    {
      title: 'Sicherheit, Datenschutz & CRA',
      description: 'Cyber Resilience Act (CRA)-Experte, CRA-Readiness, Secure-by-Design und Security-by-Default, SBOM und Software-Supply-Chain-Security, Threat Modeling, Vulnerability Management, Penetration Testing und IT Security (Kali, Tails Linux, Metasploit Framework, Nmap), IoT/OT-Security, Bluetooth Low Energy, Bluetooth Mesh, MQTT, Mosquitto, Presidio, PII und Datenschutz'
    },
    {
      title: 'Projektmethodik & KI-Transformation',
      description: 'Lean AI, Use-Case-Evaluierung, ROI/TCO-Berechnung, Prozessklassifizierung, Intent-Driven Development Enablement, Abgrenzung von IDD zu Spec-Driven Development, professionelle Ablösung von Vibe Coding, agile Entwicklung, testgetriebene Entwicklung, Scrum, Redmine, Jira, Taiga, Mantis, Requirements Engineering, Stakeholder-Kommunikation, Release-Kommunikation, Confluence und Doxygen-Dokumentation'
    }
  ],
  positions: [
    {
      period: 'Januar 2026 - Heute',
      title: 'KI-Ingenieur, Software-Architekt, Berater Rüstungsindustrie',
      technologies: 'CUDA, vLLM, Ollama, Hugging Face, MCP Python, MCP TypeScript, MCP PHP, CI/CD GitLab Pipelines, Docker, Vektordatenbanken (ChromaDB, Qdrant), RAG / GraphRAG / Agentic-RAG-Architekturen, RAG Evals, Explainable AI, Intent-Driven Development, Lean AI, OpenCode, Claude Code',
      description: [
        'Beratende Funktion bei der Erstellung und Planung einer unternehmensweiten KI-Strategie. Evaluierung und Definition von KI-Use-Cases nach Lean-AI-Projektmanagementprozessen.',
        'Berechnung von Return on Investment sowie Klassifizierung von KI-Use-Cases nach Prozessart und Wirtschaftlichkeit.',
        'Agentische Softwareentwicklung und Edge Computing: Planung und Umsetzung lokaler Alternativen zu Anthropic, um Entwicklerteams eine On-Premise-OpenCode-Experience zu ermöglichen, die Claude Code entspricht - insbesondere für KI-Use-Cases mit Daten, die unter VS-NfD (Verschlusssache - Nur für den Dienstgebrauch) eingestuft sind.',
        'Migration von Claude Code Agent Instructions und Skill Sets nach OpenCode Agent Instructions und OpenCode Skills.',
        'Planung von Hardware und Beschaffungskosten für Anforderungen, bei denen 30-köpfige Entwicklerteams gleichzeitig mit einer Time to First Token (TTFT) von unter 10 Sekunden agentisch nach IDD programmieren - mit lokalen LLMs, die in SWE-Benchmarks nahe an Claude Code heranreichen.',
        'Nach abgeschlossener Planung konkrete Implementierung agentischer, multimodaler KI-Use-Cases.',
        'Schulung von Softwareentwicklern in Intent-Driven Development (IDD), Abgrenzung gegenüber Spec-Driven Development sowie Workshops zu den Vorteilen von IDD.',
        'Etablierung strukturierter Entwicklungsprozesse für KI-gestützte Softwareentwicklung als professioneller Ersatz für unkontrolliertes Vibe Coding.'
      ]
    },
    {
      period: 'Dezember 2025 - April 2026',
      title: 'Softwareentwickler Bankenwesen',
      technologies: 'R Shiny',
      description: [
        'Implementierung eines R Shiny Dashboards zur Visualisierung und Auswertung von Globalen Banken Simulationen (GBS).'
      ]
    },
    {
      period: 'September 2025 - Dezember 2025',
      title: 'Softwareentwickler/KI-Ingenieur, Kassenzahnärztliche Vereinigung Baden-Württemberg (KZV BW)',
      technologies: 'Python, Microsoft Presidio SDK, spaCy NLP Models, FastAPI, Beeware, Docker, SQL, Datenschutz / Personally Identifiable Information (PII)',
      description: [
        'Design und Umsetzung einer generischen PII-Software, die alle Sprachen weltweit unterstützt, um persönliche und vertrauliche Daten aus Office-Dokumenten zu identifizieren, zu anonymisieren und zu de-anonymisieren.',
        'NLP-Modelle von spaCy und Microsoft Presidio Data Protection and De-identification SDK. Eine SQL-Datenbank speichert Klartext-Anonymisierung-Datenpaare. Umsetzung als dockerisierte FastAPI mit Swagger-Dokumentation, eigenständige Python-Bibliothek sowie Windows- und macOS-Standalone-Software mit Beeware und nativer Toga-UI.'
      ]
    },
    {
      period: 'August 2025 - Dezember 2025',
      title: 'Softwareentwickler/KI-Ingenieur, Industrial IoT',
      technologies: 'Python, Docker, Podman, FastAPI, OpenCV, Shiny, Kibana, HTML, CSS, Lua, Embedded Engineering',
      description: [
        'Senior Softwareentwickler für die Weiterentwicklung einer smarten stereoskopischen Kamera mit KI-Hardware auf Basis von Hailo-Prozessoren.',
        'Echtzeit-Objekterkennung und Auswertung in Python und Lua. Entwicklung einer Container-Orchestrierungs-API direkt auf Sensor-Hardware. Shiny-Log-Analyse-Dashboard und Kibana Monitoring, containerisiert und auf Sensorelektronik deployed. Web-App von der Kamera gehostet mit HTML, CSS und JavaScript.'
      ]
    },
    {
      period: 'Januar 2025 - Heute',
      title: 'Softwareentwickler/KI-Ingenieur, KRIKO Engineering GmbH',
      technologies: 'C#, gRPC, Simatic PCS7, SQL, JavaScript, React, Docker, Python, FastAPI, Swagger, PyTorch, CUDA, RAG, GRAG, Agenten, Hugging Face, R Shiny, GitLab, GitLab Runners und Executors, Azure DevOps, Taiga und Jira API',
      description: [
        'Senior Softwarearchitekt für multifunktionale agentische KI-Systeme und DevOps-Automatisierung. Entwicklung von C# gRPC-Services mit Reflection und autonomen KI-Agenten für sprachgesteuerte Codeverarbeitung in Azure DevOps und GitLab.',
        'Planung und Entwicklung von Python FastAPI Backend-Architekturen mit React TypeScript Frontend. Vollständig dockerisierte Deployments aller Systemkomponenten. Implementation von RAG/GRAG-Pipelines für intelligente Codebase-Analyse und Integration interner Dokumente, Handbücher und Schulungsunterlagen.',
        'CI/CD-Automatisierung durch KI-gesteuerte GitLab Runner und Executors, Taiga- sowie Jira-Integration und Model Context Protocol (MCP) für Multi-Agent-Kommunikation. Qualitätssicherung mit Explainable AI, Arize Phoenix, RAG-Evaluierung, Halluzinationsdetektion sowie Monitoring und Log Analysis mit R Shiny.'
      ]
    },
    {
      period: 'März 2025',
      title: 'Trainer, Kassenzahnärztliche Vereinigung Baden-Württemberg (KZV BW)',
      technologies: 'Python, PyTorch, CUDA, Docker, JupyterLab, Google Colab, Hugging Face',
      description: [
        'Theorie und Hands-on-Workshops zu generativer KI für Projekt- und Teamleiter. Überblick über die KI-Landschaft, Bewertungskriterien, optimale Use Cases, klassische ML-Verfahren, Zeitreihenanalyse, Signalverarbeitung und LLM-basierte Lösungen.',
        'Entwicklung maßgeschneiderter Edge-KI-Systeme mit RAG/GRAG-Architekturen und LoRA/QLoRA Fine-Tuning, autonome KI-Agenten, Chatbot-Lösungen, Hosting-Strategien, Investitionsanalyse, Total Cost of Ownership, Datenanonymisierung und EU-AI-Act-Compliance.'
      ]
    },
    {
      period: 'Juli 2024 - August 2024',
      title: 'Softwareentwickler, IoT',
      technologies: 'Azure IoT, Digital Twins, Event Hubs, SQL-Datenbank, Azure Functions, C# (.NET 8), REST APIs, gRPC, Docker',
      description: [
        'Entwicklung eines Digital Twins für Wasserfilter, einer lokalen Testumgebung mit Docker und Einbindung in die Azure Cloud.'
      ]
    },
    {
      period: 'Juli 2024',
      title: 'Trainer, Verlagswesen',
      technologies: 'Python, PyTorch, CUDA, Docker, JupyterLab, Google Colab, Hugging Face',
      description: [
        'Theorie und Hands-on-Workshops zu generativer KI für Projekt- und Teamleiter mit Schwerpunkt Use-Case-Auswahl, Edge-KI, RAG/GRAG, Agenten, Chatbots, Hosting-Strategien, Datenschutz, EU AI Act und Sicherheitskonzepte.'
      ]
    },
    {
      period: 'Oktober 2023 - Oktober 2025',
      title: 'Forschung und Entwicklung, KI und Robotik, Hochschule Offenburg',
      technologies: 'Python, PyTorch, LLMs, ChatGPT, RESTGPT, NanoGPT, Java, Android, REST API, Swagger, C#/C++, MS Azure, Azure DevOps Pipelines, HTML, CSS, JavaScript, Python Shiny',
      description: [
        'Entwicklung von Verfahren künstlicher Intelligenz zur Umsetzung digitaler Assistenten sowie zur Erkennung und Klassifikation von Emotionen auf Basis von Bild- und Audiodaten. Dockerisierte Prototypen mit verschiedenen GPT-Modellen, API-Implementierungen sowie Training lokaler alternativer LLMs auf Basis freier Modelle mit Web- und Nutzerdaten. Monitoring mit Shiny-Dashboard.',
        'Ansteuerung eines Telepräsenzrobotersystems und Verknüpfung des Roboters mit Serveranwendungen über REST-APIs.'
      ],
      pageBreakBefore: true
    },
    {
      period: 'August 2022 - März 2024',
      title: 'Technischer Leiter, Scrum Master Bankbereich international, T-Systems',
      technologies: 'FAME, Python, R, RMarkdown, Camunda, Docker, Kubernetes, GitLab, Confluence, Jira, R Shiny',
      description: [
        'Leitung eines Teams von Softwareentwicklern und Data Scientists in einem umfangreichen Migrationsprojekt im internationalen Bankbereich.',
        'Vorbereitung und Leitung von Team-Meetings, Retrospectives, Scrum of Scrums, Release Reviews und Kundenpräsentationen. Abstimmung mit Requirements Engineering, Product Ownern und Team Leads.',
        'Entwicklung einer R-Bibliothek zur Erzeugung standardisierter statistischer Reports durch Neuimplementierung vorhandener FAME-Logik nach R und Python. Implementierung von Camunda Executoren in Python, Pflege von Workflow-Konfigurationen, GitLab Pipelines und automatisierter Confluence-Dokumentation.'
      ]
    },
    {
      period: 'Mai 2021 - Juli 2022',
      title: 'Software Developer, Software Architect, ERGO Group AG',
      technologies: 'C#, C++, Matlab',
      description: [
        'Neuentwicklung einer in Matlab geschriebenen Software zur Bewertung und Verwaltung von Finanzprodukten in C#. Berechnung von Marktwerten und Cashflows für Bonds, Mortgages, Swaps, Swaptions, Callable Bonds, Floater und Steepener. Architektur, Entity Framework, SQLite/SQL Server, CI/CD mit Azure DevOps, Doxygen, C++/CLI, .NET 6, C++20 sowie Unit- und Integrationstests.'
      ]
    },
    {
      period: 'Mai 2019 - April 2021',
      title: 'Projekt Manager, Data Scientist, Software Developer, Druckindustrie (B2B)',
      technologies: 'Xamarin Forms, Entity Framework Core, OpenCV, SkiaSharp, Pillow, Docker, Flask API, MS Azure DevOps',
      description: [
        'Leitende Funktion bei der Entwicklung einer App zur Fälschungserkennung und Berechnung eines robusten Fingerprints für patentierte Sicherheitsetiketten. Bildverarbeitung mit SIFT, SURF, ORB, Laplace- und Fourier-Transformationen, Signal-Rausch-Analysen, CI-Deployment für Android und iOS, REST-API-Anbindung, Heartbeat-Service und Response-System.'
      ]
    },
    {
      period: 'Februar 2020 - Juni 2020',
      title: 'Data Scientist, Energietechnik (B2C)',
      technologies: 'Azure TSI, Azure Cosmos DB, Azure SQL Datenbank, Azure Functions, Azure Key Vault, pyramid ARIMA, Scikit-Learn, TensorFlow-Keras, Confluence, Jira',
      description: [
        'Vorhersage zukünftiger Energieverbräuche anhand historischer Daten und Wetterprognosen. Bewertung von ARIMA, Random Forest und LSTM mit Performance- und Gütemetriken, Azure-Time-Series-Verarbeitung, Deployment in Azure Functions, tägliche Reporting-Validierung und Dokumentation in Confluence.'
      ]
    },
    {
      period: 'September 2019 - Januar 2020',
      title: 'Projekt Manager, Data Scientist, Software Entwickler, eCommerce (B2B)',
      technologies: 'Docker, MySQL, .NET Core, Swagger, R Shiny Dashboard, ShinyProxy, Caddy',
      description: [
        'Konzeption und Ausarbeitung eines Sicherheits- und Authentifizierungskonzeptes für eine Analyseplattform im Onlinehandel. Umsetzung als Docker-basierte REST-Architektur.'
      ]
    },
    {
      period: 'Mai 2018 - Juni 2019',
      title: 'Data Scientist, Software Entwickler, Telekommunikation (B2C)',
      technologies: 'Knime, Impala Hadoop, Docker, R Shiny, ShinyProxy, Random Forests mit Scikit-Learn, Neural Networks mit TensorFlow',
      description: [
        'Prozessanalyse mit Fachbereichen, Rohdatensuche im Hadoop-Cluster via Impala und Knime, R-Logik zur KPI-Aggregation, Shiny-Dashboards, NLP-Analyse von Service-Calls, prädiktive Modelle für Außendiensteinsätze sowie produktive ML-Implementierung mit CI und Docker.'
      ]
    },
    {
      period: 'April 2017 - Mai 2018',
      title: 'Software Entwickler, Industrie und IoT (B2C)',
      technologies: 'Xamarin Forms, .NET, Bluetooth Low Energy',
      description: [
        'Entwicklung einer Mobile-App und PC-Software zur Programmierung und Steuerung von Zeitschaltuhren. Bluetooth-Stack, UDP-Discovery-Service, Roll-out-Tool und Wartungsprozess mit Drei-Personen-Team.'
      ]
    },
    {
      period: '2015 - 2017',
      title: 'System Administrator, IT-Gruppe des Instituts für Physik, Albert-Ludwigs-Universität Freiburg',
      description: [
        'Aufsetzen und Wartung von Windows- und Linux-Images mit ESXi und Xen. DHCP, CUPS, FOG-Server, LDAP-Authentifikationen, KISS-Systeme und USV-Konfigurationen.',
        'Automatisiertes Penetrationstest-System für das Institutsnetzwerk mit NMAP-Skript-Engine, Metasploit-Plugin auf CVE-Basis sowie IDS mit Snort.'
      ]
    },
    {
      period: '2016',
      title: 'Wissenschaftlicher Mitarbeiter, Physikalisches Institut, Albert-Ludwigs-Universität Freiburg',
      technologies: 'C++, CUDA, Python, R',
      description: [
        'Entwicklung und Analyse der Erkennungsraten neuronaler Netze zum Pattern Matching, darunter Boltzmann-Netze, LSTM-Netze, Hopfield- und Jordan-Netze mit unterschiedlichen Lernregeln, Aktivierungsfunktionen und Kodierungen sowie trainierte Netze zur Basislinienkorrektur in NMS- und ESR-Spektren.'
      ]
    },
    {
      period: '2012 - 2015',
      title: 'Wissenschaftlicher Mitarbeiter, Institut für Physikalische Chemie, Albert-Ludwigs-Universität Freiburg',
      technologies: 'MATLAB, TurboMol, ORCA, Gromacs MD',
      description: [
        'QM/MM-Simulationen von ESR- und NMR-Parametern für Flavo-Proteine, CHARMM-Force-Fields, Energie-Minimierung, Lignin-Potential und Kopplung thermischer Ensembles an die Simulationsbox.'
      ]
    },
    {
      period: '2011 - 2012',
      title: 'Wissenschaftlicher Mitarbeiter, Optik/Medizintechnik und Pharmazie',
      technologies: 'Mathematica, Python, R, Knime',
      description: [
        'Software zur Bestimmung von Astigmatismus und Dioptrienwerten von Augenlinsen per Machine Learning inklusive Patentimplementierung EP 2814916. Zusätzlich Untersuchung synergetischer Effekte bei Krebsmedikamenten und Implementierung des Chou Combination Index in R als Knime-Knoten.'
      ]
    },
    {
      period: '2010 - 2012',
      title: 'Finanzmathematik',
      technologies: 'C++, Python, R, Bash-Skripte',
      description: [
        'Programme zum Erhalten von Tick-Daten für WKN-Nummern und Bitcoin-Kurse, Swing-Trading-Strategien für Bitcoin, DAX, Dow Jones und STOXX 50 sowie gleitende Durchschnitte.'
      ]
    }
  ]
};
